import { Board, Difficulty } from "../types";
import { getUniqueSudoku } from "./unique";

const EMPTY_ROW = new Array(9).fill("");

export const createEmptyBoard = () => {
  const board: Board = [];
  for (let i = 0; i < 9; i++) {
    board.push([...EMPTY_ROW]);
  }
  return board;
};

export const generateUniqueSudokuBoard = (difficulty: Difficulty) => {
  const [ initArray, solvedArray ] = getUniqueSudoku(difficulty);
  const initBoard = createEmptyBoard();
  const solvedBoard = createEmptyBoard();

  for (let i = 0; i < initArray.length; i++) {
    const row = Math.floor(i / 9);
    const col = i % 9;
    initBoard[row][col] = initArray[i] === '0' ? '.' : initArray[i];
    solvedBoard[row][col] = solvedArray[i] === '0' ? '.' : solvedArray[i];
  }

  return [initBoard, solvedBoard];
}